import {
  ButtonProps,
  ImageProps,
} from 'spindl-shared-components';


type ImageContentInternalProps = {
  image?: ImageProps;
  button?: ButtonProps;
};

type ImageContentPropsValues = {
  'CellFirstSelect': ImageContentInternalProps;
  'CellSecondSelect': ImageContentInternalProps;
  'Default': ImageContentInternalProps;
  'Disabled': ImageContentInternalProps;
  'Error': ImageContentInternalProps;
  'Highlighted': ImageContentInternalProps;
};

const propValues: ImageContentPropsValues = {
  'CellFirstSelect': {
    image: {
    },
    button: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
  },
  'CellSecondSelect': {
    image: {
    },
    button: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Primary',
      state: 'Selected',
    },
  },
  'Default': {
    image: {
    },
  },
  'Disabled': {
    image: {
    },
  },
  'Error': {
    image: {
    },
  },
  'Highlighted': {
    image: {
    },
  },
};

const getProps = (type: string): ImageContentInternalProps => {
  const values: ImageContentInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
